export namespace Message {
  export const FOOTER_TEXT =
    'Government of the Republic of Zambia. All Rights Reserved. ZamPass';

  export const TOOLTIP_MFA_MESSAGE =
    'To activate this option you need to have  an Authenticator App (e.g. Google or Microsoft) to scan this QR and use the verification code generated by the app.';

  export const DEFAULT_ERROR_MESSAGE =
    'Something went wrong. Please try again later';

  export const NO_DATA_MESSAGE = 'No data available';
  export const UPDATE_PROFILE_INFORMATION =
    'By clicking Refresh, your information will be updated from National Identity Registry (NIR) records.';

  export const USERNAME_CITIZEN_LABEL = 'Username (NRC w/o slashes)';
  export const USERNAME_FOREIGNER_LABEL = 'Username (Identity document number)';
  export const USERNAME_CITIZEN_GUIDANCE =
    'Enter your 9-digit NRC number - no slashes, spaces, or letters. You will use this to sign in to your ZamPass account.';
  export const USERNAME_FOREIGNER_GUIDANCE =
    'Enter your Identity Document Number as your username. You will use this to sign in to your ZamPass account.';
  export const USERNAME_SIGNIN_GUIDANCE =
    'Enter the same identifier you used during registration - your 9-digit NRC number (for Zambian citizens), identity document number (for Foreign citizens), or email/other username.';
  export const USERNAME_CITIZEN_VALIDATION_ERROR = 'Enter a valid 9-digit NRC number without slashes';
  export const EMAIL_VALIDATION_ERROR = 'Please enter a valid email address';
  export const EMAIL_MISMATCH_ERROR = 'Email addresses do not match.';
  export const PASSWORD_MISMATCH_ERROR = 'Passwords do not match.';

  // Required field error messages
  export const FIRST_NAME_REQUIRED = 'First Name is required.';
  export const LAST_NAME_REQUIRED = 'Last Name is required.';
  export const EMAIL_REQUIRED = 'Email is required.';
  export const EMAIL_VERIFICATION_REQUIRED = 'Re-type Email Address is required.';
  export const PERSON_TYPE_REQUIRED = 'Person Type is required.';
  export const PASSWORD_REQUIRED = 'Password is required.';
  export const PASSWORD_VERIFICATION_REQUIRED = 'Re-type Password is required.';
  export const USERNAME_REQUIRED = 'Username is required.';
  export const GENDER_REQUIRED = 'Gender is required.';
  export const DATE_OF_BIRTH_REQUIRED = 'Date of Birth is required.';
  export const DATE_OF_BIRTH_MIN_AGE_ERROR = 'You must be at least 16 years old to register.';
  export const PHONE_NUMBER_REQUIRED = 'Phone Number is required.';
  export const COUNTRY_REQUIRED = 'Country is required.';
  export const DOCUMENT_TYPE_REQUIRED = 'Document Type is required.';
  export const DOCUMENT_NUMBER_REQUIRED = 'Document Number is required.';
  export const DOCUMENT_ISSUE_DATE_REQUIRED = 'Document Issue Date is required.';
  export const DOCUMENT_ISSUE_DATE_FUTURE_ERROR = 'Document Issue Date cannot be in the future.';
  export const DOCUMENT_EXPIRY_DATE_REQUIRED = 'Document Expiry Date is required.';
  export const DOCUMENT_EXPIRY_DATE_PAST_ERROR = 'Document Expiry Date must be in the future.';
}
